import React from "react";
import { Box } from "@mui/material";
import { usersColumns } from "./utils/users.columns";
import { GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import pathRoutes from "../../routes/pathRoutes";
import { CreatePageList } from "@app/components/Layouts/PageList";
import { Add } from "@app/components/Actions";
import { CustomDataGrid } from "@app/components";
import { useUser } from "@services/servicesGenericsTables";

const UsersList = () => {
  const { userList } = useUser();
  const navigate = useNavigate();
  const handleRowDoubleClick = (params: GridRowParams): void => {
    navigate(`${pathRoutes.ADMIN_USUARIOS}/editar/${params.id}`);
  };

  return (
    <CreatePageList
      title="Listado de usuarios"
      buttonRight={<Add to={`admin/usuarios/nuevo`} title="Nuevo usuario" />}
    >
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", mt: 1 }}>
        <CustomDataGrid
          rows={userList}
          columns={usersColumns}
          search={true}
          handleRowDoubleClick={handleRowDoubleClick}
        />
      </Box>
    </CreatePageList>
  );
};

export default UsersList;
